// @ts-nocheck
import { Column } from 'react-table';
import { useIntl } from 'react-intl';
import { Agency } from '../../core/_models';
import { AgencyCustomHeader } from './AgencyCustomHeader';
import { AgencyActionsCell } from './AgencyActionsCell';

const agenciesColumns: ReadonlyArray<Column<Agency>> = [
  {
    Header: (props) => (
      <AgencyCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.NAME' })}
        className='min-w-125px'
      />
    ),
    id: 'name',
    Cell: ({ row }) => <span>{row.original.name}</span>,
  },
  {
    Header: (props) => (
      <AgencyCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.CITY' })}
        className='min-w-100px'
      />
    ),
    id: 'city',
    Cell: ({ row }) => <span>{row.original.city}</span>,
  },
  {
    Header: (props) => (
      <AgencyCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.PHONE' })}
        className='min-w-100px'
      />
    ),
    id: 'phone',
    Cell: ({ row }) => <span>{row.original.phone}</span>,
  },
  {
    Header: (props) => (
      <AgencyCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.STATUS' })}
        className='min-w-75px'
      />
    ),
    id: 'isActive',
    Cell: ({ row }) => (
      <span className={`badge ${row.original.isActive ? 'badge-light-success' : 'badge-light-danger'}`}>
        {row.original.isActive ? 'Active' : 'Inactive'}
      </span>
    ),
  },
  {
    Header: (props) => (
      <AgencyCustomHeader tableProps={props} title='' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({ ...props }) => <AgencyActionsCell id={props.data[props.row.index]._id} />,
  },
];

export { agenciesColumns };
